module.exports = __webpack_public_path__ + "pic/chat_system.47095196.png";